<template>
  <HeaderWarningPanel :visible="daysLeft !== null && daysLeft >= 0 && daysLeft < 10">
    {{ $tc('password_expires_in_days', daysLeft, { day: daysLeft }) }}.
  </HeaderWarningPanel>
</template>

<script setup>
import {computed} from "vue"
import {useStore} from "vuex"
import moment from "moment"
import HeaderWarningPanel from "@/components/parts/general/HeaderWarningPanel.vue"

const store = useStore()

const user = computed(() => store.state.auth.user)
const validUntil = computed(() => user.value?.password_valid_until || null)
const daysLeft = computed(() => {
  if(!validUntil.value) return null
  let now = moment()
  return Math.ceil(moment(validUntil.value).diff(now, 'days', true))
})
</script>
